import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import abcae7ac9fa37e1ba62e5b2dc74440b8eb from "./generated-8d61d478-6b8d-4876-9e50-54f200f00740.json";

import a5ed65aeb812898d7bf9c425b32560501b from "./generated-d5b52716-f817-43c1-9010-f39dbefc3692.json";

import adfdd7f1cd8dc2f1fdd66d8a914222075b from "./generated-c3b945b7-0585-435c-8e5d-938f9d841b6d.json";

import ac35380cab41a5a2a83de76dd1e1c9432b from "./generated-d24ac640-cb49-4196-9750-246e26e572fc.json";

import a5734d7f829fab366fb4bc3b3299cdf53b from "./generated-02106b2e-70d1-49c6-94da-175a6f8e50cf.json";

import aed8946a97da41dde34d55453236616f7b from "./generated-2420829b-afad-4a17-a0b3-dfc118f88c0a.json";

import a25da6837375b26e4ecdbe6177651ea82b from "./generated-4e313991-e956-4254-8e82-d637f0b01ac7.json";

import a052ae1ae347d88cc209e55fd928e3de7b from "./generated-4d7e0e05-c4c2-4ac6-adaf-4e503bbbd1c8.json";

import aaa131f9549b21c8672c6a3680aaae35bb from "./generated-50b63b61-7b78-42b9-a021-25abe98816ad.json";

import a266375646ba775e52f5328783c924f9eb from "./generated-51730f33-92e7-441c-92ee-20bee804b113.json";

import ac4bd07f678cf51828e2ab6abd8a2c261b from "./generated-4b56b69a-d999-4e38-81d6-6f6dc31678e8.json";

import a05753418571c956dea25d850281f883cb from "./generated-73358edf-f852-4d46-b89c-932b0a748cd8.json";

import a9069f5411fd6ccf41f204b0a8b85c572b from "./generated-dcecbdc7-be17-4c41-b393-7bb0d99049ce.json";

import aa7d4a43381f0a6d130001922e3836a7cb from "./generated-54c7258e-0fd8-4ce6-ad5c-92e640fbf8dd.json";

import afe967ab83d30d4b557ed00e56174f520b from "./generated-e19363e9-c1c7-4794-b67e-0d15b9a8e83a.json";

import a1331730c097e8be327e54aef5e09fa0ab from "./generated-b799d8ef-8c3b-428b-8cc8-1b866a2e791b.json";

import a86368e366a72107cc51c54a9b482fb87b from "./generated-48384e6f-e495-4601-bd77-03c35258f7f0.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(abcae7ac9fa37e1ba62e5b2dc74440b8eb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a5ed65aeb812898d7bf9c425b32560501b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(adfdd7f1cd8dc2f1fdd66d8a914222075b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ac35380cab41a5a2a83de76dd1e1c9432b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a5734d7f829fab366fb4bc3b3299cdf53b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(aed8946a97da41dde34d55453236616f7b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a25da6837375b26e4ecdbe6177651ea82b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a052ae1ae347d88cc209e55fd928e3de7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aaa131f9549b21c8672c6a3680aaae35bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a266375646ba775e52f5328783c924f9eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ac4bd07f678cf51828e2ab6abd8a2c261b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a05753418571c956dea25d850281f883cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aaa131f9549b21c8672c6a3680aaae35bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a9069f5411fd6ccf41f204b0a8b85c572b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aa7d4a43381f0a6d130001922e3836a7cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(aaa131f9549b21c8672c6a3680aaae35bb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(afe967ab83d30d4b557ed00e56174f520b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a1331730c097e8be327e54aef5e09fa0ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a86368e366a72107cc51c54a9b482fb87b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(afe967ab83d30d4b557ed00e56174f520b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */